import React from "react";
import Category from "./Category";
import * as styles from "./Categories.module.scss";

const Categories = ({ title, color, allCategories, category }) => {
  const matchedCategory = allCategories?.find(
    (cat) => cat.name.toLowerCase() === category.toLowerCase()
  );

  const parentId = matchedCategory ? matchedCategory.patternCategory : null;

  const childCategories =
    allCategories?.filter((e) => e.patternCategory === parentId) || [];
  return (
    <div className={`${styles.categories__container}`}>
      <div className={`${styles.categories__content}`}>
        <div className={styles.categories__category}>
          {childCategories.map((cat, index) => {
            const transformCategoryName = (name) => {
              return name.toLowerCase().replace(/ /g, "-");
            };

            const imgSrc =
              cat.thumbnail !== null
                ? cat.thumbnail
                : "https://peabody.com.ar/images/batidora-de-mesa-pe-bm190r_1_700x500.jpg";

            return (
              <Category
                colorSelected={color}
                key={index}
                name={cat.name}
                img={imgSrc}
                isActive={cat.name.toLowerCase() === category.toLowerCase()}
                href={transformCategoryName(cat.name)}
              />
            );
          })}
        </div>
      </div>
    </div>
  );
};

export default Categories;
